import { Button } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { ScenarioMetadata } from "in_queue/types/scenarioType";
import { downloadSizeAdjustments } from "./sizeAdjustments";

export const ExportAssumptionsButton: React.FC<{
    scenario: ScenarioMetadata;
    className?: string;
}> = ({ scenario, className }) => (
    <Button
        className={className}
        icon={IconNames.EXPORT}
        text="Export"
        minimal
        // Both headers this sits in toggle their section on click.
        onClick={(event) => {
            event.stopPropagation();
            downloadSizeAdjustments(scenario);
        }}
    />
);
